import { render, staticRenderFns } from "./BrandingSenderSection.vue?vue&type=template&id=7416e4ed&scoped=true"
import script from "./BrandingSenderSection.vue?vue&type=script&lang=js"
export * from "./BrandingSenderSection.vue?vue&type=script&lang=js"
import style0 from "./BrandingSenderSection.vue?vue&type=style&index=0&id=7416e4ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7416e4ed",
  null
  
)

export default component.exports